export default __webpack_public_path__ + "a6eb50086c3384b50c0d4a3290f52305.svg";